import React, { useMemo } from 'react';
import { InjectedFormProps, reduxForm } from 'redux-form';
import { FieldInput } from '../../../../../components/redux-form/fields/FieldInput';
import { maxLength, required, Validators } from '../../../../../components/redux-form/utils/validators';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import styles from '../assets/recovery-request-form.module.scss';

import { FormError } from 'src/components/redux-form/FormError';
import { asyncAuthResetPasswordRequest } from '../../../../../store/actions/auth-actions';
import { Link } from 'react-router-dom';
import Router from '../../../../../navigation/router';
import { routes } from '../../../../../navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';

export interface RecoveryRequestFormData {
    username: string;
}
interface RecoveryRequestFormProps {}

type InjectedProps = InjectedFormProps<RecoveryRequestFormData, RecoveryRequestFormProps>;

const RecoveryRequestForm: React.FunctionComponent<InjectedProps & RecoveryRequestFormProps> = ({
    handleSubmit,
    submitting,
    error,
}: InjectedProps & RecoveryRequestFormProps) => {
    const { t } = useTranslation();
    const validators: Validators<RecoveryRequestFormData> = useMemo(
        () => ({
            username: [required(), maxLength({ max: 180 })],
        }),
        [],
    );

    return (
        <div className={classNames('')}>
            <div className={classNames('col-lg-3')}></div>
            <div className={classNames(styles.authContent)}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginTop: '30px',
                        marginBottom: '10px',
                    }}
                >
                    <div className={classNames(styles.infoIcon, '  d-flex justify-content-center align-items-center')}>
                        <FontAwesomeIcon className={classNames(styles.icon)} icon={faQuestion} />
                    </div>
                    <div className={classNames(styles.infoIconTitle)}>Forgot the password</div>
                </div>

                <form onSubmit={handleSubmit} className={classNames(styles.form)}>
                    <div className={classNames(styles.login)}>
                        <FieldInput
                            name="username"
                            type="text"
                            validate={validators.username}
                            wrapperConfig={{
                                label: t('Enter your email:'),
                            }}
                        />
                        <FormError error={error} />
                    </div>
                    <div className={classNames('text-center')}>
                        <button type="submit" className={classNames(styles.mainButton, 'btn', 'btn-success', 'text-uppercase')}>
                            {submitting ? <span className={classNames('spinner-border')} /> : t('Restore')}
                        </button>
                    </div>
                    <div className={classNames(styles.links, 'text-center', 'mb-2')}>
                        <Link to={Router.generate(routes.HOME)}> back to login</Link>
                    </div>
                </form>
            </div>
            <div className={classNames('col-lg-3')}></div>
        </div>
    );
};

export default reduxForm<RecoveryRequestFormData, RecoveryRequestFormProps>({
    form: 'password-recovery-request',
    onSubmit: asyncAuthResetPasswordRequest,
})(RecoveryRequestForm);
